// extracted by mini-css-extract-plugin
export default {"root":"_xoBULhV","img":"_1pWoQkAV","fit":"XCY58nZg","spinner":"_2f8_zoFb","visible":"_1Z20qEZ1","inline":"_3-n_7lQl"};